var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4167 3.66675H4.58341C3.57089 3.66675 2.75008 4.48756 2.75008 5.50008V13.7501H0.916748V16.5001C0.916748 17.5126 1.73756 18.3334 2.75008 18.3334H19.2501C20.2626 18.3334 21.0834 17.5126 21.0834 16.5001V13.7501H19.2501V5.50008C19.2501 4.48756 18.4293 3.66675 17.4167 3.66675ZM17.4167 13.7501H4.58341V5.50008H17.4167V13.7501ZM2.75008 16.5001V15.5834H19.2501V16.5001H2.75008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.08b11870434adb578f3f625a1c73c651.svg";
export { ForwardRef as ReactComponent };